import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const LIST: AppRouteRecordRaw = {
  path: '/promotion', // 推广 
  name: 'promotion',
  permission: 'platform',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.promotion',
    requiresAuth: true,
    icon: 'icon-send',
    order: 5,
    permission: 'platform',
  },
  children: [
    // {
    //   path: 'promotionLink', // The midline path complies with SEO specifications
    //   name: 'promotionLink',
    //   permission: 'promotion:link',
    //   component: () => import('@/views/promotion/link/index.vue'),
    //   meta: {
    //     locale: 'menu.promotionLink',
    //     requiresAuth: true,
    //     roles: ['*'],
    //     permission: 'promotion:link',
    //   },
    // },
    // {
    //   path: 'myMerchant', // The midline path complies with SEO specifications
    //   name: 'myMerchant',
    //   permission: 'promotion:merchant',
    //   component: () => import('@/views/person/myMerchant/index.vue'),
    //   meta: {
    //     locale: 'menu.myMerchant',
    //     requiresAuth: true,
    //     roles: ['*'],
    //     permission: 'promotion:merchant',
    //   },
    // },
    // {
    //   path: 'myTeam', // The midline path complies with SEO specifications
    //   name: 'myTeam',
    //   permission: 'promotion:team',
    //   component: () => import('@/views/person/myTeam/index.vue'),
    //   meta: {
    //     locale: 'menu.myTeam',
    //     requiresAuth: true,
    //     roles: ['*'],
    //     permission: 'promotion:team',
    //   },
    // },
    // {
    //   path: 'myAccount', // The midline path complies with SEO specifications
    //   name: 'myAccount',
    //   permission: 'promotion:account',
    //   component: () => import('@/views/person/myAccount/index.vue'),
    //   meta: {
    //     locale: 'menu.myAccount',
    //     requiresAuth: true,
    //     roles: ['*'],
    //     permission: 'promotion:account',
    //   },
    // },
    {
      path: 'promotionTeam', // The midline path complies with SEO specifications
      name: 'promotionTeam',
      permission: 'platform:qrcode',
      component: () => import('@/views/promotion/team/index.vue'),
      meta: {
        locale: 'menu.promotionTeam',
        requiresAuth: true,
        roles: ['*'],
        permission: 'platform:qrcode',
      },
    },
    {
      path: 'promotionIncome', // The midline path complies with SEO specifications
      name: 'promotionIncome',
      permission: 'promotion:income',
      component: () => import('@/views/promotion/income/index.vue'),
      meta: {
        locale: 'menu.promotionIncome',
        requiresAuth: true,
        roles: ['*'],
        permission: 'promotion:income',
      },
    },
  ],
};

export default LIST;
